module.exports = __webpack_public_path__ + "06d1ac4488f51ac634f85bedf246da15.png";